import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Paper,
  Collapse,
  TableBody,
  Typography,

} from "@mui/material";

import moment from "moment";
import { PaymentListProvider } from "../context/Listprovider";
import DetailsCard from "../CashierDetailsComponent/DetailsCard";

import { Fragment, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { patientientPaymentDetails } from "../../../../../PatientCare/Cashier/v2/Service";
import { useLocation } from "react-router-dom";
import { useFetchPatientDetailsByEMR } from "../../../../../PatientCare/hookv2/apiHooks";
import { PatientFullDetailsType } from "../../../../../PatientCare/PatientBooking/v2/types";
import CustomTableBody from "@utilifiles/component/CustomTableBody";
import { patientPayDetailsBIllsNoAndDates } from "../../type";


const LedgerDetailsPage = () => {
  const [patientDetails, setPatientDetails] = useState<patientPayDetailsBIllsNoAndDates | null>(null)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const emrno = queryParams.get("emrno") || "";
  console.log("patientId", emrno)
  const headings = [
    "Date",
    "No of Bills",
    "Balance",

  ];
  const [_patientData, setPatientData] = useState<PatientFullDetailsType | null>(null);

  const { mutate: getPatientData } = useFetchPatientDetailsByEMR({
    onSuccess: (result: any) => {
      setPatientData(result.response);
    },
  });

  useEffect(() => {
    if (emrno) {
      getPatientientPaymentDetails(emrno);
      const emrNo = emrno;
      getPatientData({ emrNo, encounterId: 0 });
    }
  }, [emrno]);

  const { mutate: getPatientientPaymentDetails, isLoading: ledgerLoading, } = useMutation(
    patientientPaymentDetails,
    {
      onSuccess: (data: any) => {
        const responseData = data.response;
        if (!responseData) return;
        console.log("dataresponseDataresponseData..............", patientDetails?.dates.map((item) => item.date))
        setPatientDetails(responseData);
      }
    }
  );
  return (
    <PaymentListProvider>
      <Box sx={{ p: 2 }}>
        {/* Patient Details */}
        <DetailsCard setDetails={setPatientData} />
        <Paper elevation={4} sx={{ mt: 2 }}>
          <Box
            sx={{
              p: 2,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              Patient Ledger Details
            </Typography>
          </Box>
          <Table
            size="small"
            sx={{
              "& .MuiTableCell-root": {
                border: "1px solid",
                borderColor: "divider",
                padding: "8px",
              },
            }}
          >
            {/* MAIN HEADER */}
            <TableHead
              sx={(theme) => ({
                backgroundColor: theme.palette.primary.main,
              })}
            >
              <TableRow>
                {headings.map((head) => (
                  <TableCell
                    key={head}
                    align={head === "Balance" ? "right" : "left"}
                    sx={(theme) => ({
                      color: theme.palette.background.paper,
                      fontWeight: 600,
                      height: 38,
                    })}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <CustomTableBody
              alert="No ledger records"
              dataLoading={ledgerLoading}   // if you have loading state use it here
              isData={Boolean(patientDetails?.dates?.length)}
              totalSpan={{ col: headings.length, row: 5 }}
            >
              {[...(patientDetails?.dates || [])].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).map((dateItem, index) => {
                const isOpen = true;
                const sortedBills = [...(dateItem.paydetails || [])].reverse();

                const totalPayable = sortedBills.reduce((sum, bill) => sum + (Number(bill.patientShareAmount) || 0), 0);
                const totalReceived = sortedBills.reduce((sum, bill) => sum + (Number(bill.amountPayed) || 0), 0);
                const totalDiscount = sortedBills.reduce((sum, bill) => sum + (Number(bill.patientShareAmount - bill.amountPayed - bill.balanceAmount) || 0), 0);
                const totalBalance = sortedBills.reduce((sum, bill) => sum + (Number(bill.balanceAmount) || 0), 0);

                return (
                  <Fragment key={index}>
                    {/* OUTER SUMMARY ROW */}
                    <TableRow
                      hover
                      sx={{
                        backgroundColor: "#f8fafc",
                        "& > td": {
                          fontWeight: 700,
                          fontSize: "0.95rem",
                          borderBottom: "none",
                        }
                      }}
                    >
                      <TableCell sx={{ color: "primary.main" }}>
                        {moment(dateItem.date).format("DD MMM YYYY")}
                      </TableCell>

                      <TableCell>
                        <Box component="span" sx={{ 
                          bgcolor: "primary.main", 
                          color: "primary.contrastText", 
                          px: 2.5, 
                          py: 0.5, 
                          borderRadius: 1, 
                          fontSize: '0.75rem',
                          fontWeight: 600
                        }}>
                          {dateItem.paydetails?.length} Bills
                        </Box>
                      </TableCell>

                      <TableCell align="right" sx={{ color: "error.main !important" }}>
                       {Number(dateItem.patientShareAmount).toFixed(2)}
                      </TableCell>
                    </TableRow>

                    {/* INNER COLLAPSE */}
                    <TableRow>
                      <TableCell
                        colSpan={headings.length}
                        sx={{ padding: 0, borderBottom: "2px solid #cbd5e1" }}
                      >
                        <Collapse
                          in={isOpen}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box sx={{ margin: 2, mt: 0, borderRadius: 2, overflow: "hidden", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)" }}>
                            <Table size="small">
                              <TableHead sx={{ backgroundColor: "#f1f5f9" }}>
                                <TableRow>
                                  <TableCell sx={{ fontWeight: 600, color: "text.secondary", py: 1.5 }}>Date</TableCell>
                                  <TableCell sx={{ fontWeight: 600, color: "text.secondary", py: 1.5 }}>Doctor</TableCell>
                                  <TableCell sx={{ fontWeight: 600, color: "text.secondary", py: 1.5 }}>Bill No</TableCell>
                                  <TableCell align="right" sx={{ fontWeight: 600, color: "text.secondary", py: 1.5 }}>Payable Amount</TableCell>
                                  <TableCell align="right" sx={{ fontWeight: 600, color: "text.secondary", py: 1.5 }}>Received</TableCell>
                                  <TableCell align="right" sx={{ fontWeight: 600, color: "text.secondary", py: 1.5 }}>Discount</TableCell>
                                  <TableCell align="right" sx={{ fontWeight: 600, color: "text.secondary", py: 1.5 }}>Balance</TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {sortedBills.map((bill, i) => {
                                  return (
                                    <TableRow 
                                      key={i}
                                      sx={{ 
                                        backgroundColor: sortedBills.length > 1 && i % 2 !== 0 ? "#f8fafc" : "#ffffff",
                                      }}
                                    >
                                      <TableCell sx={{ color: "text.secondary" }}>
                                        {moment(bill.date).format("DD MMM YYYY")}
                                      </TableCell>

                                      <TableCell sx={{ fontWeight: 500 }}>
                                        {bill.doctorName}
                                      </TableCell>

                                      <TableCell sx={{ color: "primary.main", fontWeight: 500 }}>
                                        {bill.billNo}
                                      </TableCell>

                                      <TableCell align="right" sx={{ fontWeight: 500 }}>
                                        {Number(bill.patientShareAmount).toFixed(2)}
                                      </TableCell>

                                      <TableCell align="right" sx={{ color: "success.main", fontWeight: 600 }}>
                                        {Number(bill.amountPayed).toFixed(2)}
                                      </TableCell>

                                      <TableCell align="right" sx={{ fontWeight: 500 }}>
                                        {Number(bill.patientShareAmount - bill.amountPayed - bill.balanceAmount || 0).toFixed(2)}
                                      </TableCell>

                                      <TableCell align="right" sx={{ color: "error.main", fontWeight: 600 }}>
                                        {Number(bill.balanceAmount).toFixed(2)}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                                {/* Inner Table Totals */}
                                {sortedBills.length > 0 && (
                                  <TableRow sx={{ backgroundColor: "#f1f5f9" }}>
                                    <TableCell colSpan={3} sx={{ fontWeight: 700, textAlign: "right", py: 1.5, color: "text.secondary" }}>
                                      Total:
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700, py: 1.5 }}>
                                      {totalPayable.toFixed(2)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700, py: 1.5, color: "success.main" }}>
                                      {totalReceived.toFixed(2)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700, py: 1.5 }}>
                                      {totalDiscount.toFixed(2)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700, py: 1.5, color: "error.main" }}>
                                      {totalBalance.toFixed(2)}
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </Fragment>
                );
              })}
              {/* Outer Table Grand Totals */}
              {patientDetails?.dates && patientDetails.dates.length > 0 && (
                <TableRow sx={{ backgroundColor: "#e2e8f0" }}>
                  <TableCell sx={{ fontWeight: 700, fontSize: "1rem", py: 2 }}>Grand Total</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: "1rem", py: 2 }}>
                    {patientDetails.dates.reduce((sum, date) => sum + (date.paydetails?.length || 0), 0)} Bills
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700, fontSize: "1rem", py: 2, color: "error.main" }}>
                    {patientDetails.dates.reduce((sum, date) => sum + Number(date.patientShareAmount || 0), 0).toFixed(2)}
                  </TableCell>
                </TableRow>
              )}
            </CustomTableBody>
          </Table>
        </Paper>
      </Box>
    </PaymentListProvider>
  );
};

export default LedgerDetailsPage;